import { useQuery } from '@apollo/client';

import { CompanyProfile } from '__generated__/GQL';
import useCompanyContext from 'common/hooks/useCompanyContext';

import { MINIMUM_LATE_FEE_FALLBACK } from '../../../../../../constants';
import { DEFAULT_MAX_CREDIT_CARD_PAYMENT } from '../../constants';
import { InvoiceFormDocument } from './graphql/invoiceForm.gql';

const clientsFirst = 10000000;

export const useInvoiceFormQuery = () => {
  const { companyProfileId } = useCompanyContext();
  const { data, ...hook } = useQuery(InvoiceFormDocument, {
    skip: !companyProfileId,
    variables: {
      companyProfileId: companyProfileId ?? '',
      first: clientsFirst,
    },
  });

  return {
    bankAccount: {
      bic: data?.viewer?.company?.bankAccount?.bic ?? '',
      iban: data?.viewer?.company?.bankAccount?.iban ?? '',
    },
    clients:
      data?.viewer?.company?.clients?.edges?.map(({ node }) => ({
        ...node,
        invoiceClientId: node.clientId,
      })) || [],
    company: data?.viewer?.company?.profile as CompanyProfile,
    metadata: {
      maxAmountForCardPayment:
        data?.viewer?.company?.metadata?.maxInvoiceCardPayment ??
        DEFAULT_MAX_CREDIT_CARD_PAYMENT,
      minLatePaymentFee:
        data?.invoiceMinimumLateFee ?? MINIMUM_LATE_FEE_FALLBACK,
    },
    ...hook,
  };
};

export const refetchInvoiceForm = (companyProfileId: string) => ({
  query: InvoiceFormDocument,
  variables: {
    companyProfileId,
    first: clientsFirst,
  },
});
